import React from 'react';
import compact from 'lodash/compact';
import classnames from 'classnames';

import { ContentBlock } from '../ContentBlock/ContentBlock';
import Image from '../Image';
import { HeroComponentFragment } from '../../../graphql.schema';
import { useImageResize } from '../../hooks/useImageResize';

import * as styles from './HeroComponent.module.scss';

const HeroComponent = ({
  image,
  optional_image,
  title,
  intro,
  links,
  button,
}: Omit<HeroComponentFragment, '__typename'>) => {
  const { imageWrapper } = useImageResize(image ?? optional_image);

  return (
    <div className={classnames('hero-component', styles.root)}>
      <div ref={imageWrapper} className={styles.featuredImage} data-testid='image-component'>
        <Image image={image ?? optional_image} className={styles.image} loading="eager" />
      </div>

      <div className={styles.content} data-testid='contentblock-component'>
        <ContentBlock
          isFluid
          titleOverride={<h1 className={classnames('title is-2')}>{title}</h1>}
          title={title}
          content={intro ?? ''}
          links={compact(links)}
          button={button ?? undefined}
        />
      </div>
    </div>
  );
};

export default HeroComponent;
